import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { UPDATE_STAFF_INFO_BY_STAFF_ID, UPDATE_USER_INFO_BY_USER_ID } from 'graphql/service';
import { debouncedErrorMessage } from 'utils/messageUtil';
import { message } from 'antd';

export const useStaffForm = () => {

  const staffInfo = useSelector(state => state.staffInfoReducer.staffInfo)
  const [staffInfoError, setStaffInfoError] = useState({})

  const [updateUserInfoByUserId, { loading: updateUserInfoLoading }] = useMutation(
    UPDATE_USER_INFO_BY_USER_ID,
    {
      onCompleted: (updateUserInfoData)=> {
        if(updateUserInfoData?.updateUser?.id) {
          message.success('Staff Info updated successfully!')  
        } else {
          const content = 'Update failed'
          debouncedErrorMessage(content);
        }
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  )
  const [updateStaffInfoByStaffId, { loading: updateStaffInfoLoading }] = useMutation(
    UPDATE_STAFF_INFO_BY_STAFF_ID
  )
  
  //function for valid form, make sure nonempty field in the form
  const isValidForm = () => {

    let result = true
    if (!staffInfo.streetAddress) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, streetAddressError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, streetAddressError: false}))
    }

    if (!staffInfo.streetAddressLine2) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, streetAddressLine2Error: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, streetAddressLine2Error: false}))
    }

    if (!staffInfo.city) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, cityError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, cityError: false}))
    }

    if (!staffInfo.province) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, provinceError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, provinceError: false}))
    }

    if (!staffInfo.postalCode) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, postalCodeError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, postalCodeError: false}))
    }

    if (!staffInfo.country) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, countryError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, countryError: false}))
    }

    if (!staffInfo.fullName) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, fullNameError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, fullNameError: false}))
    }

    if (!staffInfo.email) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, emailError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, emailError: false}))
    }

    if (!staffInfo.phoneNumber) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, phoneNumberError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, phoneNumberError: false}))
    }

    if (!staffInfo.roles) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, rolesError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, rolesError: false}))
    }

    if (!staffInfo.status) {
      result = false;
      setStaffInfoError((staffInfoError)=>({...staffInfoError, statusError: true}))
    } else {
      setStaffInfoError((staffInfoError)=>({...staffInfoError, statusError: false}))
    }

    return result
  }

  //helper parse function to parse google address component
  // const parseStringAddress = (stringAddress) => {
  //   const parts = stringAddress?.split(', ');
  //   const streetAddress = parts[0]
  //   const city = parts[1]
  //   const province = parts[2]?.split(' ')[0]
  //   const postalCode = parts[2]?.split(' ')[1] + ' ' + parts[2]?.split(' ')[2]
  //   const country = parts[3]
  
  //   return {
  //     streetAddress,
  //     city,
  //     province,
  //     postalCode,
  //     country,
  //   };
  // }

  const updateStaffInfo = () => {

    if (isValidForm()) {

      const userId = staffInfo.userId;
      const staffId = staffInfo.staffId;
      const fullName = staffInfo.fullName
      const email = staffInfo.email
      const phoneNumber = staffInfo.phoneNumber
      const streetAddress = staffInfo.streetAddress
      const streetAddressLine2 = staffInfo.streetAddressLine2
      const city = staffInfo.city
      const province = staffInfo.province
      const postalCode = staffInfo.postalCode
      const country = staffInfo.country
      const roles = staffInfo.roles
      const status = staffInfo.status

      updateUserInfoByUserId({
        variables: {
          userId,
          input: {
            fullName,
            email,
            username: email,
            phoneNumber,
            address: streetAddress,
            addressLine2: streetAddressLine2,
            city,
            province,
            postalCode,
            country
          }
        }
      }) 

      // updateStaffInfoByStaffId({
      //   variables: {
      //     staffId,
      //     input: {
      //       roles,
      //       phoneNumber,
      //       roles,
      //       status
      //     }
      //   },
      // })

    } else {
      const content = 'Please fill the form!'
      debouncedErrorMessage(content);
    }
  };

  return {
    updateStaffInfo,
    updateStaffInfoLoading,
    staffInfoError,
    setStaffInfoError
  }
}
